export const SERVER_ERROR =
  "One problem is on server side. Please try again later.";
export const NOT_FOUND_ERROR =
  "Please check internet status. And then try again, please.";
export const BAD_REQUEST =
  "Sorry! We can't handle your requirement. Please try later";
